<mpro-dropdown class="projection" title="Projections" [inputValue]="getCurrentProjectionsList()" [disabled]="isDisabledValue">
    <div class="dropdown-content-wrapper">
        <div class="dropdown-header">
            <span>Select up to 3 years for comparison.</span>
            <hr>
        </div>
        <mpro-checkable-dropdown-item *ngFor="let projection of projections"
            [checked]="isChecked(projection)"
            [disabled]="isDisabled(projection)"
            [leftText]="projection.toString()"
            (itemChecked)="onProjectionSelected($event, projection)">
        </mpro-checkable-dropdown-item>
    </div>
</mpro-dropdown>